export const themeOptions = {
  palette: {
    mode: "dark",
    primary: {
      main: "rgb(91,28,230)",
      light: "#48288470",
      contrastText: "#F9F871",
    },
    secondary: {
      main: "#F9F871",
      contrastText: "#482884",
    },
    info: {
      main: "#482884",
    },
    background: {
      paper: "#482884",
      default: "#482884",
    },
    text: {
      primary: "#F9F871",
      secondary: "#482884",
    },
  },
  typography: {
    fontFamily: "Arial",
    fontWeightLight: 500,
    fontWeightRegular: 600,
    fontWeightMedium: 700,
    fontWeightBold: 900,
  },
};
